export default {
  SAVE_LOOK_DATA_TO_STORE: 'looks/SAVE_LOOK_TO_STORE',
  SAVE_LOOKS_DATA_TO_STORE: 'looks/SAVE_LOOKS_DATA_TO_STORE',
};
